import { InputAdornment, TextField } from '@mui/material';
import { FC, FocusEventHandler, forwardRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

export type CurrencyInputChangeEvent = {
	target: {
		value: string;
	};
};

type CurrencyFormatProps = {
	onBlur: FocusEventHandler<HTMLInputElement>;
	onChange: (event: CurrencyInputChangeEvent) => void;
};

type CurrencyInputProps = CurrencyFormatProps & {
	value: string;
};

const CustomCurrencyFormat = forwardRef<NumericFormatProps, CurrencyFormatProps>((props, ref) => {
	const { onBlur, onChange, ...rest } = props;

	return (
		<NumericFormat
			{...rest}
			thousandSeparator
			valueIsNumericString
			fixedDecimalScale
			decimalScale={2}
			allowNegative={false}
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						value: values.value,
					},
				});
			}}
			onBlur={(e) => {
				// remove separators from value before invoking onBlur callback
				e.target.value = e.target.value.split(',').join('');
				onBlur(e);
			}}
		/>
	);
});

export const CurrencyInput: FC<CurrencyInputProps> = ({ value, onBlur, onChange }) => (
	<TextField
		size='small'
		value={value}
		onBlur={onBlur}
		onChange={onChange}
		InputProps={{
			inputComponent: CustomCurrencyFormat as any,
			startAdornment: <InputAdornment position='start'>$</InputAdornment>,
		}}
	/>
);
